var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMutedSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2450",
    width: 78.861,
    height: 68.052,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Lautsprecher_off"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lautsprecher_off",
    clipPath: "url(#clip-Lautsprecher_off)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1334",
    transform: "translate(35.569 40.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1334-2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_602",
    d: "M17.291,45.56H5V22.492H23.169a2.5,2.5,0,0,0,1.749-.713L42.051,5.011l1.563,0v14.23l5-5V2.5a2.5,2.5,0,0,0-2.5-2.5h-.006L41.022.014A2.5,2.5,0,0,0,39.28.727L22.15,17.492H2.5a2.5,2.5,0,0,0-2.5,2.5V48.06a2.5,2.5,0,0,0,2.5,2.5h9.791Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_603",
    d: "M43.614,40.449V63.031l-1.559-.013L31.428,52.635,27.893,56.17,39.281,67.3a2.5,2.5,0,0,0,1.726.712l5.086.043h.021a2.5,2.5,0,0,0,2.5-2.5v-30.1Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_604",
    d: "M69.271,14.792,65.7,18.366A19.046,19.046,0,0,1,73.86,34.025c0,7.418-4.381,13.928-11.719,17.414a2.5,2.5,0,1,0,2.145,4.517c9.126-4.335,14.575-12.534,14.575-21.931a24.3,24.3,0,0,0-9.59-19.233",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_605",
    d: "M61.537,22.527,57.95,26.114a9.463,9.463,0,0,1,4.157,7.912c0,3.852-2.206,7.109-6.054,8.936A2.5,2.5,0,1,0,58.2,47.479c5.578-2.649,8.908-7.679,8.908-13.421a14.486,14.486,0,0,0-5.57-11.531",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_606",
    d: "M68.033,5.424a2.5,2.5,0,0,0-3.535,0L10.829,59.093a2.5,2.5,0,1,0,3.535,3.535L68.033,8.959a2.5,2.5,0,0,0,0-3.535",
    fill: "inherit"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedSpeaker);
export default __webpack_public_path__ + "static/media/mutedSpeaker.72529e39c6b8a5c18c23ed4cca69643e.svg";
export { ForwardRef as ReactComponent };